import React from "react";
import { Copy, ExternalLink, Send } from "lucide-react";
import { toast } from "sonner";
import { Button } from "../ui/button";
import { StatusBadge } from "../shared/StatusBadge";
import { paymentLinkStatusMeta, paymentPurposeLabel } from "../../lib/statusMaps";
import { formatCurrency } from "../../lib/utils";
import { useTaxConfig, computeGst } from "../../lib/tax";

export function PaymentLinkCard({ link, onResend, resending, testId = "payment-link-card" }) {
  const taxCfg = useTaxConfig();
  if (!link) return null;
  const meta = paymentLinkStatusMeta(link.status);
  const bd = computeGst(link.amount, taxCfg);

  const copyLink = () => {
    navigator.clipboard.writeText(link.url);
    toast.success("Payment link copied to clipboard");
  };

  return (
    <div className="rounded-md border border-border bg-background p-3 text-sm" data-testid={testId}>
      <div className="mb-2 flex items-center justify-between">
        <p className="font-medium text-text-main">{paymentPurposeLabel(link.purpose)} Link · {formatCurrency(bd.total)}{bd.enabled && <span className="ml-1 text-xs font-normal text-text-muted">(incl. {formatCurrency(bd.gst)} GST)</span>}</p>
        <StatusBadge label={meta.label} variant={meta.variant} />
      </div>
      <div className="flex items-center gap-2 rounded border border-border bg-surface px-2 py-1.5">
        <span className="flex-1 truncate text-xs text-text-muted" data-testid={`${testId}-url`}>{link.url}</span>
        <button type="button" onClick={copyLink} className="flex-shrink-0 text-text-muted hover:text-primary" data-testid={`${testId}-copy-button`}>
          <Copy size={14} strokeWidth={1.5} />
        </button>
        <a href={link.url} target="_blank" rel="noreferrer" className="flex-shrink-0 text-text-muted hover:text-primary" data-testid={`${testId}-open-link`}>
          <ExternalLink size={14} strokeWidth={1.5} />
        </a>
      </div>
      <div className="mt-2 flex items-center justify-between text-xs text-text-muted">
        <span>{link.email_sent ? "Email sent (stub)" : "Email not sent"} · Provider: {link.provider}</span>
        {onResend && link.status === "pending" && (
          <Button variant="ghost" size="sm" onClick={onResend} disabled={resending} data-testid={`${testId}-resend-button`}>
            <Send size={13} strokeWidth={1.5} /> {resending ? "Sending..." : "Resend"}
          </Button>
        )}
      </div>
    </div>
  );
}
